import {Component, forwardRef, Injector} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {AbstractInput} from '../abstract-input';

@Component({
    providers: [
        {
            multi: true,
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DurationInputComponent)
        }
    ],
    selector: 'vui-duration-input',
    templateUrl: './duration-input.component.html',
    styleUrls: ['./duration-input.component.scss']
})
export class DurationInputComponent extends AbstractInput {
    public days: number;
    public hours: number;
    public minutes: number;

    constructor(protected injector: Injector) {
        super(injector);
    }

    /**
     * Update the value using the combination of the different duration
     * units and turning them back into seconds
     */
    public change(): void {
        this.value = Math.floor(this.days * (3600 * 24)) + Math.floor(this.hours * 3600) + Math.floor(this.minutes * 60);
    }

    public get value(): number {
        return this._value;
    }

    /**
     * Store the seconds that have been provided individually as days, hours, and minutes
     * and convert them from seconds into their respective units.
     * @param value
     */
    public set value(value: number) {
        this._value = value;
        this.changed(this._value);
        this.days = Math.floor(this._value / (3600 * 24));
        this.hours = Math.floor(this._value % (3600 * 24) / 3600);
        this.minutes = Math.floor(this._value % 3600 / 60);
    }
}
